export function LoginPage() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-neutral-50">
            <div className="bg-white rounded-lg shadow-sm border border-neutral-200 p-10 text-center max-w-sm w-full">
                <h1 className="text-xl font-semibold text-neutral-900 mb-2">Marque Central</h1>
                <p className="text-sm text-neutral-500 mb-8">Sign in with your Coravant account to continue.</p>
                <a
                    href="/bff/signin"
                    className="inline-flex items-center justify-center w-full px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors"
                >
                    Sign in with Microsoft
                </a>
            </div>
        </div>
    )
}
